/*
 * AdminUsers Messages
 *
 * This contains all the text for the AdminUsers component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  emailAddress: {
    id: 'app.common.emailAddress',
    defaultMessage: 'Email Address',
  },
  send: {
    id: 'app.common.send',
    defaultMessage: 'Send',
  },
  next: {
    id: 'app.common.next',
    defaultMessage: 'Next',
  },
  sendInvitationByEmail: {
    id: 'app.components.AdminUsers.sendInvitationByEmail',
    defaultMessage: 'Send the invitation to an email address.',
  },
  addEmail: {
    id: 'app.components.AdminUsers.addEmail',
    defaultMessage: 'Add Email Address',
  },
  invitationsSent: {
    id: 'app.components.AdminUsers.invitationsSent',
    defaultMessage: 'The {count, plural, one {invitation has} other {invitations have}} been sent',
  },
  importParentMails: {
    id: 'app.components.AdminUsers.importParentMails',
    defaultMessage: 'Import Parents Email Addresses',
  },
  importParentMailsIntro: {
    id: 'app.components.AdminUsers.importParentMailsIntro',
    defaultMessage: 'If you have a list of email addresses of parent, you can upload the list and send invitations by email.',
  },
  importEmployeeMailsIntro: {
    id: 'app.components.AdminUsers.importEmployeeMailsIntro',
    defaultMessage: 'Import Employee Email Addresses',
  },
  importEmployeeMails: {
    id: 'app.components.AdminUsers.importEmployeeMails',
    defaultMessage: 'Import Employee Email Addresses',
  },
  users: {
    id: 'app.containers.Dashboard.users',
    defaultMessage: 'Users',
  },
  selectFile: {
    id: 'app.components.SelectFiles.any',
    defaultMessage: 'Select file',
  },
  getStarted: {
    id: 'app.components.PhotoBook.getStarted',
    defaultMessage: 'Let\'s Get Started!',
  },
  firstName: {
    id: 'app.components.Name.firstName',
    defaultMessage: 'First name',
  },
  middleName: {
    id: 'app.components.AdminGroups.middleName',
    defaultMessage: 'Affix',
  },
  lastName: {
    id: 'app.components.Name.lastName',
    defaultMessage: 'Last name',
  },
  birthDate: {
    id: 'app.components.AdminUsers.birthDate',
    defaultMessage: 'Date of Birth',
  },
  email1: {
    id: 'app.components.AdminUsers.email1',
    defaultMessage: 'Email Address Parent 1',
  },
  email2: {
    id: 'app.components.AdminUsers.email2',
    defaultMessage: 'Email Address Parent 2',
  },
  matchColumns: {
    id: 'app.components.AdminUsers.matchColumns',
    defaultMessage: 'Match Columns',
  },
  matchColumnsIntro: {
    id: 'app.components.AdminUsers.matchColumnsIntro',
    defaultMessage: 'Match the columns from the sheet with the corresponding data fields.',
  },
  confirmSubmit: {
    id: 'app.components.AdminUsers.confirmSubmit',
    defaultMessage: 'Confirm and Submit',
  },
  numSheetRows: {
    id: 'app.components.AdminUsers.numSheetRows',
    defaultMessage: 'This sheet contains {count, plural, one {# row} other {# rows}} with data.',
  },
  selectParentsFileIntro: {
    id: 'app.components.AdminUsers.selectParentsFileIntro',
    defaultMessage: 'Your file must have the names and birthdate of the student, and the email addresses of parents, as listed below. You can use <a>our template</a>.',
  },
  selectFileIntro: {
    id: 'app.components.SelectFiles.selectFileIntro',
    defaultMessage: 'Your file must have the following columns, you can use <a>our template</a>:',
  },
  namesNotFound: {
    id: 'app.components.AdminUsers.namesNotFound',
    defaultMessage: 'The following names could not be matched to existing {roleName, select, student {students} employee {employees} other {??}}. Please check the data and update the sheet.',
  },
  noNamesFound: {
    id: 'app.components.AdminUsers.noNamesFound',
    defaultMessage: 'No further names were found.',
  },
  namesFound: {
    id: 'app.components.AdminUsers.namesFound',
    defaultMessage: 'The {remaining, select, true {remaining } other {}}{count, plural, one {name was} other {# names were}} matched and invitations can be sent to the corresponding email addresses.',
  },
  sendInvitations: {
    id: 'app.components.AdminUsers.sendInvitations',
    defaultMessage: 'Send Invitations',
  },
});
